import React from "react";
import { Icon } from "@mdi/react";
import Button from "components/Button";
import { mdiCheck, mdiPaperclip } from "@mdi/js";
import clsx from "clsx";
import { COLOR_BY_STATUS } from "constants/base";

type ContractType =
  | "STD_BROKER"
  | "NON_FACTORED_STANDARD"
  | "NON_FACTORED_BILL_OUT"
  | "SELF_FINANCE_WITH_INVOICE"
  | "SELF_FINANCE_NO_INVOICE";

type DocumentType = string;
type StatusType = string;

interface DocumentStatusIconProps {
  contractType: ContractType;
  documentTypes: DocumentType[];
  status: StatusType;
}

const REQUIRED_DOCUMENTS: Record<ContractType, DocumentType[] | null> = {
  STD_BROKER: ["Signed Bill of Lading (Delivered)"],
  NON_FACTORED_STANDARD: ["Signed Bill of Lading (Delivered)", "TONU"],
  NON_FACTORED_BILL_OUT: ["Signed Bill of Lading (Delivered)", "TONU"],
  SELF_FINANCE_WITH_INVOICE: ["Signed Bill of Lading (Delivered)"],
  SELF_FINANCE_NO_INVOICE: null
};

const DocumentStatusIcon: React.FC<DocumentStatusIconProps> = ({
  contractType,
  documentTypes,
  status
}) => {
  const required = REQUIRED_DOCUMENTS[contractType];

  const isComplete =
    required === null ||
    (Array.isArray(required) && required.some((doc) => documentTypes.includes(doc)));
  const iconColor = isComplete
    ? "text-approvedBorder border border-approvedBorder"
    : COLOR_BY_STATUS[status];

  return (
    <Button
      iconButton
      rounded
      type="button"
      size="sm"
      className={clsx("border !bg-transparent", iconColor)}>
      <Icon
        path={isComplete ? mdiCheck : mdiPaperclip}
        className={clsx("size-4.5 !border-0", iconColor)}
      />
    </Button>
  );
};

export default DocumentStatusIcon;
